export class Question{
  id: number;
  loaded: boolean = false;
  title: string;
  required: boolean = false;
  tip: string|null;
  nextId: number|null = null;
  prevId: number|null = null;
  canAnswer: boolean = false;
  answered: boolean = false;
  correctAnswer: boolean = false;
  image: string|null;
  /** Resolved blob URLs for all stem figures (HTML order). */
  imageUrls: string[] | null = null;

  public answers: {
    option: string;
    label: string;
    value: number;
    isCorrect: boolean;
    isChecked: boolean;
    isDisabled: boolean;
    tip: string|null;
  }[];
  constructor(id:number, title:string, tip: string|null, nextId:number|null, prevId:number|null, canAnswer:boolean,image: string|null,
              answers:{
                option:string,
                label:string,
                value:number,
                isCorrect:boolean,
                isChecked:boolean,
                isDisabled: boolean,
                tip:string|null
              }[]) {
    this.id = id;
    this.title = title;
    this.tip = tip;
    this.nextId = nextId;
    this.prevId = prevId;
    this.canAnswer = canAnswer;
    this.answers = answers;
    this.image = image;
  }
}
